<template>
    <div style="margin-bottom:15px;margin-top:15px;">
        <div v-for="model in question.answers" v-bind:key="model.uid">
            <div style="margin-top:10px;margin-bottom:10px;">
                <button @click="locateMe(model)" type="button" class="btn btn-success">Get location</button>
            </div>
            <gmap-map
                    :id="model.uid"
                    :zoom="12"
                    :center="center"
                    @click="onMapClick($event, model)"
                    style="width:100%;  height: 600px;"
            >
                <gmap-marker
                        v-for="m in model.markers"
                        :key="m.id"
                        :position="m.position"
                />
            </gmap-map>
            <label
                    :for="question.uid" v-bind:class="{ selected: model.selected }">
            </label>
            <input type="hidden" v-model="model.value" class="form-control" :placeholder="model.title"
                   :name="question.uid">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'google-maps',
        props: ['question'],
        mounted() {
        },
        data() {
            return {
                center: {lat: this.question.config.map_center_lat, lng: this.question.config.map_center_lng},
                markers: {}
            }
        },
        methods: {
            onMapClick(e, model) {
                model.markers = [];
                console.log(e.latLng);
                let newMarkers = [{
                    id: model.uid,
                    position: e.latLng,
                }];
                model.value = `${e.latLng.lat()},${e.latLng.lng()}`;
                model.markers = newMarkers;
            },
            async getLocation() {

                return new Promise((resolve, reject) => {

                    if (!("geolocation" in navigator)) {
                        reject(new Error('Geolocation is not available.'));
                    }
                    navigator.geolocation.getCurrentPosition(pos => {
                        resolve(pos);
                    }, err => {
                        reject(err);
                    });

                });
            },
            async locateMe(model) {
                try {
                    let position = await this.getLocation();

                    let lat = position.coords.latitude;
                    let lng = position.coords.longitude;

                    model.markers = [];

                    let newMarkers = [{
                        id: model.uid,
                        position: {lat: lat, lng: lng}
                    }];

                    model.value = `${lat},${lng}`;
                    model.markers = newMarkers;

                    this.center = {lat: lat, lng: lng};

                } catch (e) {
                    console.log(e);
                }

            }
        },
        components: {}
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .10s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }
</style>
